function directive($state, $location, $window) {
    // this appends the page head (title and calendar) to all pages, so they can have their own controller
    return {
        // restrict: 'E',
        link: function ($scope) {
            $scope.title = $state.current.data.title;
            $scope.daterange = $state.current.data.daterange;

            // subheading display
            $scope.subtitle = [];
            if (typeof $state.current.data.subtitleElm !== 'undefined') {
                $scope.subtitleElm = $state.current.data.subtitleElm;
                for (var i in $scope.subtitleElm) $scope.subtitle.push({
                    title: i,
                    value: $location.$$search[$scope.subtitleElm[i]]
                });
            }
            $window.scroll(0,0);
        },
        template:
            `<section ng-show="title">
                <div class="row-fluid">
                    <div class="span7">
                        <h1>{{ title }}</h1>
                    </div>
                    <div class="span5">
                        <div date-picker class="datepicker2015">
                            <div ng-show="daterange" id="daterange" class="pull-right dashboard-date-range tooltips no-tooltip-on-touch-device responsive" data-tablet="" data-desktop="tooltips" data-placement="top" data-original-title="Change dashboard date range">
                                 <i class="fa fa-calendar"></i>
                                 <span>{{dateRangeStart}} - {{dateRangeEnd}}</span>
                                 <i class="fa fa-angle-down"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </section>`,
        // transclude : true
    };
}

directive.$inject = ['$state', '$location', '$window'];
module.exports = directive;


/** WEBPACK FOOTER **
 ** ./src/pages/directives/head/head.js
 **/